import { createModuleActionCreators } from "src/utils";
import { NAME } from "./constants";

const { createEmptyAction } = createModuleActionCreators(NAME);

export const openMobileMenu = createEmptyAction("OPEN_MOBILE_MENU");
export const closeMobileMenu = createEmptyAction("CLOSE_MOBILE_MENU");
